/*=========================================================================================
  File Name: moduletimeTableMutations.js
  Description: timeTable Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  SET_SCHEDULE(state, payload) {
    state.schedules = payload
  },
  CREATE_SCHEDULE(state, payload) {
    state.schedules.push(payload)
  },
  DELETE_SCHEDULE(state, payload) {
    var index = state.schedules.findIndex(function(item){return item.id == payload})
    if(index != -1){
      state.schedules.splice(index,1)
    }
  },
  UPDATE_SCHEDULE(state, payload) {
    const index = state.schedules.findIndex((e) => e.id == payload.id)
    if(index != -1){
      Object.assign(state.schedules[index], payload)
    }
  },

}
